import { HashRouter, Routes, Route } from 'react-router-dom'
import Open from './Open'
import { HomeView } from '../views/home'
import { BlocknatorPolicyView } from '../views/blocknator-policy'

const AppRoutes = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path='/' element={<Open></Open>}>
          <Route path='/' element={<HomeView></HomeView>} />
          <Route path='/policy/blocknator' element={<BlocknatorPolicyView/>} />
        </Route>
      </Routes>
    </HashRouter>
  )
}

export default AppRoutes